var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomNavBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 482,
    height: 80,
    viewBox: "0 0 482 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1403_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 80L142 80H146L482 80C472.5 79.6537 452 69.0909 436 38.961C419.99 8.812 395.833 0 385.5 0L146 0H142L96.5 0C86.1667 0 62.0102 8.812 46 38.961C30 69.0909 9.5 79.6537 0 80Z",
    fill: "#4E81F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1403_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 482,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 80)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomNavBg);
export default __webpack_public_path__ + "static/media/bottomNavBg.4b6207be3a481030535542d4d7e1e126.svg";
export { ForwardRef as ReactComponent };